export default __webpack_public_path__ + "static/media/icon-stack.794862df.svg";